module.exports = __webpack_public_path__ + "static/media/Facebook icon.b143cfee.svg";